<template>
<div class="content_card_content">
<div class="grid">
<div class="col-10">
<h4 class="text-primary">{{$store.state.languages.lang_phrases.aktif_duzeltme_talepleri}}</h4>
<hr>
</div>
<div class="col-2" v-if="requests.length">
<p class="text-purple-500  pt-2"><b>{{requests.length}} {{$store.state.languages.lang_phrases.adet}}</b></p>
</div>
</div>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
  
<template v-else>
  <template v-if="!requests.length">
    <div class="flex align-items-center justify-content-center mb-8 mt-8">

<h3 class="text-primary font-medium mb-8 mt-8">{{$store.state.languages.lang_phrases.henuz_hic_kayıt_olusturulmamis}}</h3>

</div>
  </template>
<ScrollPanel style="width: 100%; height: 280px" v-if="requests.length">
<DataTable :value="requests"  >
    <Column field="flowsupplier" :header="$store.state.languages.lang_phrases.isim" >
    	<template #body="{data}">
        <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.flowsupplier.supplier.id}}"><p>{{data.flowsupplier.supplier.name}}</p></router-link>
    </template>

    </Column>
    <!--<Column field="flowsupplier.supplier.suppliercode" :header="$store.state.languages.lang_phrases.tedarikci_kodu" ></Column>-->
    <Column field="flowsupplier.flow.brand.name" :header="$store.state.languages.lang_phrases.marka" ></Column>
    <Column field="flowsupplier.flow.project.name" :header="$store.state.languages.lang_phrases.proje" >
      
      <template #body="{data}">{{getTheTranslation(data.flowsupplier.flow.project,"translation")}}</template>
    </Column>
    <Column field="flowsupplier.flow.name" :header="$store.state.languages.lang_phrases.akis" >
      
      <template #body="{data}">{{getTheTranslation(data.flowsupplier.flow,"translation")}}</template>
    </Column>
    <Column>
    	<template #body="{data}">
    		<Button :label="$store.state.languages.lang_phrases.goruntule"  class="p-button-white  p-button-sm rightmargin" @click="goToProjectSummaryPage(data.flowsupplier.uuid)" />
    	</template>

    </Column>
</DataTable>
</ScrollPanel>



</template>



</div>
</template>

<script>
export default {

  name: 'CorrectionRequests',

  data () {
    return {
    	requests:[],
    	loading:true,
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		this.loading = true
  		this.requests = await this.generalApiGetWithoutLoader("get_correction_requests")
  		console.log("requests")
      console.log(this.requests)
  		this.loading = false
  	},
  	async goToProjectSummaryPage(uuid)
  	{
  		let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+uuid)
  		await this.$router.push({ name: 'SupplierProject',params:{id:projectsupplier.supplier_id,project_id:projectsupplier.uuid} })
  	},
  },
}
</script>

<style lang="css" scoped>
</style>